//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import template from '@legacy-components/nav3/app-switcher-menu.html';

angular.module('curalate').component('appSwitcherMenu', {
  template,
});
